import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getHublet } from '../store/app/selectors';
export const getBlogSettings = state => {
  const hublet = getHublet(state);
  const requestUrl = `${getFullUrl('app-api', {
    hubletOverride: hublet
  })}/blog-settings/v1/blogs`;
  return apiClient.get(requestUrl);
};